import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getCustomerAuthUser } from '../../services/storage/customerFlow';
import { WEB_BOOKING_ENABLED } from '../../config/env';

/**
 * Guards the signed-in customer area, following the same shape as
 * `CompanyOwnerRoute` and `AdminRoute`.
 *
 * Two gates, and the order matters. The feature flag comes first: while web
 * booking is off the area does not exist at all, and a signed-in customer who
 * guesses the URL should get the 404 they would have got last week rather than
 * a login prompt for a page that is not live.
 *
 * Unlike the company-owner guard this does NOT clear the session on failure —
 * an anonymous visitor reaching /account has nothing to clear, and wiping a
 * half-valid session would log people out of the marketing site for visiting a
 * URL.
 */
const CustomerRoute: React.FC = () => {
  const location = useLocation();

  if (!WEB_BOOKING_ENABLED) {
    return <Navigate replace to="/" />;
  }

  if (!getCustomerAuthUser()) {
    return <Navigate replace state={{ from: location }} to="/login" />;
  }

  return <Outlet />;
};

export default CustomerRoute;
